<template>
  <former-container class="returns-list-filters">
    <former-select
      v-for="field in fields"
      :key="field.id"
      class="returns-list-filters-item"
      :field="field"
      :value="field.value"
      inline
      @change="value => change(field.id, value)"
    />
  </former-container>
</template>

<script>
  import { mapState } from 'vuex';

  import optionsHelper from '@cordel/helpers/form/select/options';
  import { select } from '@/_CRUDL/helpers/form/fields';

  import preload from '@/helpers/mixins/preload';
  import former from '@/helpers/mixins/former';

  import { INITIAL_RETURN_FILTERS } from '@/store/modules/financing-return-rules';

  import FormerContainer from '@/components/Former/Container.vue';
  import FormerSelect from '@/components/Former/Field/Select.vue';

  export default {
    name: 'ReturnsSearchFilter',
    components: {
      FormerContainer,
      FormerSelect,
    },
    mixins: [
      former,
      preload,
    ],
    props: {
      loading: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        visible: false,
      };
    },
    computed: {
      ...mapState([
        'financingReturnRules',
        'returnDomains',
      ]),

      fields() {
        const {
          return_preference: returnPreference,
          quota_preference: quotaPreference,
          max_return: maxReturn,
          min_return: minReturn,
          vehicle_model_id: vehicleID,
          bank_id: bankID,
          store_id: storeID,
        } = this.financingReturnRules.list.filters;

        const {
          bank: bankOptions,
          max_return: maxReturnOptions,
          min_return: minReturnOptions,
          quota_preference: quotaPreferenceOptions,
          return_preference: returnPreferenceOptions,
          store: storeOptions,
          vehicle_model: vehicleOptions,
        } = this.returnDomains.list.items;

        const prepare = options => optionsHelper((options || [])
          .filter(o => o.id), { manipulate: v => String(v) });

        return {
          store_id: {
            ...select,
            id: 'store_id',
            placeholder: 'Filtrar por loja',
            value: storeID || null,
            options: prepare(storeOptions),
          },
          bank_id: {
            ...select,
            id: 'bank_id',
            placeholder: 'Filtrar por banco',
            value: bankID || null,
            options: [{
              value: 'null',
              label: 'Todos os bancos',
            }].concat(
              prepare(bankOptions),
            ),
          },
          vehicle_model_id: {
            ...select,
            id: 'vehicle_model_id',
            placeholder: 'Filtrar por veículo',
            value: vehicleID || null,
            options: [{
              value: 'null',
              label: 'Todos os veículos',
            }].concat(
              prepare(vehicleOptions),
            ),
          },
          min_return: {
            ...select,
            id: 'min_return',
            placeholder: 'Filtrar por retorno mínimo',
            value: minReturn || null,
            options: prepare(minReturnOptions),
          },
          max_return: {
            ...select,
            id: 'max_return',
            placeholder: 'Filtrar por retorno máximo',
            value: maxReturn || null,
            options: prepare(maxReturnOptions),
          },
          return_preference: {
            ...select,
            id: 'return_preference',
            placeholder: 'Filtrar por retorno prioritário',
            value: returnPreference || null,
            options: prepare(returnPreferenceOptions).map(option => ({
              ...option,
              label: [null, 'null'].includes(option.label) ? 'Em branco' : option.label,
            })),
          },
          quota_preference: {
            ...select,
            id: 'quota_preference',
            placeholder: 'Filtrar por parcela prioritária',
            value: quotaPreference || null,
            options: prepare(quotaPreferenceOptions).map(option => ({
              ...option,
              label: [null, 'null'].includes(option.label) ? 'Em branco' : option.label,
            })),
          },
        };
      },
    },
    mounted() {
      this.preloadReturnDomains();
    },
    beforeDestroy() {
      this.$emit('change', {
        ...INITIAL_RETURN_FILTERS,
      });
    },
    methods: {
      change(id, value) {
        let updating = value;

        if (Array.isArray(INITIAL_RETURN_FILTERS[id])) {
          updating = updating ? [updating] : [];
        }

        this.$emit('change', {
          [id]: updating,
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@/assets/stylesheets/_variables.scss';

  .returns-list-filters {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    margin: 0 var(--product--pwa--horizontal);

    > :nth-child(-n + 3) {
      flex-basis: 25%;
    }

    > :nth-child(n + 4) {
      flex-basis: 33%;
    }

    @media all and (min-width: $breakpoint-desktop) {
      align-items: flex-start;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: stretch;
      margin: 0 var(--product--pwa--horizontal);
    }
  }

  .returns-list-filters-item {
    flex: 1;
    margin: $gutter-smaller 0;

    @media all and (min-width: $breakpoint-desktop) {
      flex: auto;
      margin: $gutter-smaller $gutter-small $gutter-smallest;
    }

    // IE hack
    @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
      flex: 1;
    }
  }
</style>
